/**
 * Drive Stripe `handleNextAction` for a `requires_action` `clientAction` (TMMAPP-0015).
 */
import { billingClientConfigApi } from '@/api/billingClientConfig';
import type { ClientAction } from '@/api/billing';
import { getStripe } from './stripeSdk';

export type CompleteActionResult =
  { kind: 'completed' } | { kind: 'failed'; message: string | null } | { kind: 'unsupported' };

export async function completeClientAction(
  clientAction: ClientAction | null,
): Promise<CompleteActionResult> {
  const secret = clientAction?.clientSecret;
  if (!secret) return { kind: 'unsupported' };
  const config = await billingClientConfigApi.get();
  if (config.kind !== 'stripe') return { kind: 'unsupported' };
  const account = clientAction.connectedAccountId ?? config.config.stripeAccount;
  const stripe = await getStripe(config.config.publishableKey, account);
  if (!stripe) return { kind: 'failed', message: null };
  const result = await stripe.handleNextAction({ clientSecret: secret });
  if (result.error) {
    return {
      kind: 'failed',
      message: result.error.type === 'card_error' ? (result.error.message ?? null) : null,
    };
  }
  return { kind: 'completed' };
}
